import React from "react";
import CloseButton from "react-bootstrap/CloseButton";
import Modal from "react-bootstrap/Modal";
// import rowExample from "./images/waffle-row-example.png";
// import junctionExample from "./images/waffle-junction-example.png";
// import ylgyExample from "./images/waffle-oney-onegy-example.png";
// import gngyExample from "./images/waffle-onegn-onegy-example.png";

export default class RulesModal extends React.Component {
  render() {
    return (
      <Modal
        {...this.props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title className="h5" id="contained-modal-title-vcenter">
            HOW TO PLAY
          </Modal.Title>
          <CloseButton variant="white" onClick={this.props.onHide} />
        </Modal.Header>
        <Modal.Body>
        <h2 className="h4 fw-bold mb-3">Solve the Word Puzzle in 15 Moves or Less</h2>
        <p>Welcome to the ultimate word challenge! Rearrange the letters on the board to form the correct horizontal and
            vertical words. Every puzzle can be solved in a minimum of <strong>10 moves</strong>, but you’ll have <strong>15
                moves</strong> to complete the challenge. </p>
        <p>For every move you have left once the puzzle is solved, you’ll earn a ⭐ <strong>star reward</strong>. </p>
        <p>Use your logic and creativity to find the perfect word combinations. Drag letters anywhere on the puzzle board to
            rearrange them. As you move letters, their <strong>color will change</strong> to indicate whether they’re in the
            correct position or if they belong elsewhere in the puzzle. </p>
        <p>The number of moves remaining is displayed at the bottom of the board, so use your strategy wisely! </p>
        <h2 className="h4 fw-bold mb-3">Color System:</h2>
        <p>Here’s how the color system works to guide you: </p>
        <ol>
            <li><strong>Correct Letter Placement</strong><br />These letters are already in the correct spot for their
                respective word:
                <div className="grid text-center text-capitalize my-3" style={{ gridTemplateRows: "repeat(1, 70px)" }}>
                  <div>
                    <div id="00" className="letter" draggable="true" style={{ backgroundColor: "rgb(58, 139, 56)" }}>
                      C
                    </div>
                  </div>
                  <div>
                    <div id="20" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      R
                    </div>
                  </div>
                  <div>
                    <div id="43" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      A
                    </div>
                  </div>
                  <div>
                    <div id="34" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      Z
                    </div>
                  </div>
                  <div>
                    <div id="04" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      Y
                    </div>
                  </div>
                </div>
                </li>
            <li><strong>Letter in the Wrong Position</strong><br />This letter belongs in this word but needs to be
                moved:
                <div className="grid text-center text-capitalize my-3" style={{ gridTemplateRows: "repeat(1, 70px)" }}>
                  <div>
                    <div id="00" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      S
                    </div>
                  </div>
                  <div>
                    <div id="20" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      H
                    </div>
                  </div>
                  <div>
                    <div id="43" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>
                      O
                    </div>
                  </div>
                  <div>
                    <div id="34" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      O
                    </div>
                  </div>
                  <div>
                    <div id="04" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                      T
                    </div>
                  </div>
                </div>
              </li>
            <li><strong>Letter in the Vertical Word, Wrong Position</strong> This letter is part of the vertical word but
            needs repositioning:
            <>
            <div className="grid text-center text-capitalize my-3">
                <div></div>
                <div></div>
              <div>
                <div id="00" class="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>L</div>
              </div>
                <div></div>
                <div></div> 
                <div></div>
                <div></div>
              <div>
                <div id="41" class="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>I</div>
              </div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              <div>
                <div id="02" class="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>F</div>
              </div>
                <div></div>
                <div></div>
            </div>
          </>
          </li>
            <li><strong>Letters on Corners (Shared Between Words)</strong><br />A corner letter belongs to either the vertical
                or horizontal word:
                <div className="grid text-center text-capitalize my-3" style={{ gridTemplateRows: "repeat(1, 70px)" }}>
                  <div></div>
                  <div></div>
                  <div>
                    <div id="23" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>J</div>
                  </div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div>
                    <div id="14" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>U</div>
                  </div>
                  <div>
                    <div id="22" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>M</div>
                  </div>
                  <div>
                    <div id="21" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>P</div>
                  </div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </li>                
        </ol>
        <h2 className="h4 fw-bold mb-3">Special Scenarios</h2>
        <h3 className="h5 fw-bold mb-3">Duplicate Letters in a Single Word</h3>
        <p>If a word contains duplicate letters, only one of them will be highlighted as in the mystery word. Once one of these
            letters is placed correctly, additional duplicates will no longer be needed for that word. </p>
        <p>Example:<br />The word must use only one "E" even though there are two in this setup: </p>
        <ul>
            <li>Incorrect:<br />
              <div className="grid text-center text-capitalize my-3" style={{ gridTemplateRows: "repeat(1, 70px)" }}>
                <div>
                  <div id="00" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>
                    R
                  </div>
                </div>
                <div>
                  <div id="20" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>
                    E
                  </div>
                </div>
                <div>
                  <div id="43" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>
                    E
                  </div>
                </div>
                <div>
                  <div id="34" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>
                    D
                  </div>
                </div>
                <div>
                  <div id="04" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>
                    S
                  </div>
                </div>
              </div>
            </li>
            <li>Correct Placement:<br />Once one "E" is positioned correctly, the others are no longer
                necessary:
                <div className="grid text-center text-capitalize my-3" style={{ gridTemplateRows: "repeat(1, 70px)" }}>
              <div>
                <div id="00" className="letter" draggable="true" style={{ backgroundColor: "rgb(58, 139, 56)" }}>
                  R
                </div>
              </div>
              <div>
                <div id="20" className="letter" draggable="true" style={{ backgroundColor: "rgb(58, 139, 56)" }}>
                  E
                </div>
              </div>
              <div>
                <div id="34" className="letter" draggable="true" style={{ backgroundColor: "rgb(58, 139, 56)" }}>
                  D
                </div>
              </div>
              <div>
                <div id="04" className="letter" draggable="true" style={{ backgroundColor: "rgb(58, 139, 56)" }}>
                  S
                </div>
              </div>
            </div>  
          </li>
        </ul>
        <h2 className="h4 fw-bold mb-3">The DOUBLE TANGO Scenario</h2>
        <p>Sometimes, both horizontal and vertical words require the same letter, but not necessarily from the same instance of
            that letter. </p>
        <p>Example:<br />Horizontal: BRAVE<br />Vertical: CRANE </p>
        <div className="grid text-center text-capitalize my-3 justify-content-center">
          <div></div>
          <div></div>
          <div>
            <div id="14" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>C</div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div>
            <div id="24" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>R</div>
          </div>
          <div></div>
          <div></div>
          <div>
            <div id="43" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>B</div>
          </div>
          <div>
            <div id="41" className="letter" draggable="true" style={{ backgroundColor: "rgb(63, 65, 65)" }}>R</div>
          </div>
          <div>
            <div id="22" className="letter" draggable="true" style={{ backgroundColor: "rgb(58, 139, 56)" }}>A</div>
          </div>
          <div>
            <div id="21" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>V</div>
          </div>
          <div>
            <div id="34" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>E</div>
          </div>
          <div></div>
          <div></div>
          <div>
            <div id="20" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>N</div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div>
            <div id="02" className="letter" draggable="true" style={{ backgroundColor: "rgb(181, 150, 38)" }}>E</div>
          </div>
          <div></div>
          <div></div>
        </div>

        <p>Solution: The shared “A” falls into place for both words, while other letters adjust accordingly. </p>
        <h3 className="h5 fw-bold mb-3">Tips for Success</h3>
        <ul>
            <li>Pay attention to color changes as you move letters—it’s a clue to their correct placement! </li>
            <li>Focus on corner letters first, as they often influence multiple words. </li>
            <li>Be mindful of duplicate letters—they might not all be necessary for solving the puzzle.</li>
        </ul>
        <p>Now it’s time to dive into the puzzle board and prove your word-solving skills! Can you solve it efficiently and earn
            all 5 stars?</p>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    );
  }
}
